import { SloDTOFromJSON } from '@atlassiansox/phobos-client-ts';
import React, { FC, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { apiFetch } from '@/services';
import { joinEventsToSlo } from '@/ui';
import { applySloDefaults } from '@/views/slo-view/utils';
import { useFetchErrorController } from '@/controllers';
import { querySpec } from '@/services/api-service/api-queries';
import GroupCard from '@/components/composed/slo-card/group-card';

import SearchPageSkeleton from '../search-page-skeleton';

import * as styles from './styles';

type SearchListSLOGroupCardProps = {
  id: string;
};

const SearchListSLOGroupCard: FC<SearchListSLOGroupCardProps> = ({ id }) => {
  const { onError } = useFetchErrorController();

  const { queryKey: slosKey, path: slosPath } = querySpec('slo-group.{id}', {
    id,
  });
  const { data: rawSloData, isInitialLoading } = useQuery(slosKey, () => apiFetch(slosPath), {
    onError,
  });

  const data = useMemo(
    () => rawSloData && joinEventsToSlo([], [], applySloDefaults(SloDTOFromJSON(rawSloData))),
    [rawSloData]
  );

  if (isInitialLoading)
    return (
      <div css={styles.cardSkeletonStyles}>
        <SearchPageSkeleton isCompact />
      </div>
    );

  if (!data) return null;
  return (
    <div css={[styles.cardSloContentStyles, styles.cardSloGroupContentStyles]}>
      <GroupCard {...data} isCompact isResponsive isLarge />
    </div>
  );
};

export default SearchListSLOGroupCard;
